module.exports = __webpack_public_path__ + "static/media/Bowie.a41e52fb.png";